import DimensionNPSDisplay from '../DimensionNPSDisplay';

/**
 * Summary card: alert-style headline, top 3 struggling items
 * Definition: NPS < 0 AND count >= 10
 */
function StrugglingStoresSummary({ data, totalStrugglingCount, dimConfig, onClick, error }) {
    if (error) {
        return (
            <div className="dim-widget-error">
                <div>Unable to load struggling data.</div>
            </div>
        );
    }

    const hasStruggling = totalStrugglingCount > 0;

    return (
        <div
            className={`dim-widget-card ${hasStruggling ? 'struggling' : 'struggling-ok'}`}
            onClick={onClick}
            role="region"
            aria-label="Struggling Stores"
        >
            <div className="dim-widget-header">
                <span className="widget-icon">{hasStruggling ? '⚠️' : '✅'}</span>
                Needs Attention
            </div>
            <div className={`dim-widget-headline ${hasStruggling ? 'alert' : 'positive'}`}>
                {hasStruggling
                    ? `${totalStrugglingCount} ${totalStrugglingCount === 1 ? dimConfig.itemLabel?.toLowerCase() || 'item' : dimConfig.plural} need${totalStrugglingCount === 1 ? 's' : ''} attention`
                    : `All ${dimConfig.plural} performing well`
                }
            </div>
            <div className="dim-widget-subtitle">
                All time, 10+ reviews
            </div>
            <div className="dim-widget-body">
                {data.length > 0 ? (
                    <ul className="dim-widget-list">
                        {data.map(row => (
                            <li key={row.dimension_value}>
                                <span className="item-name">{row.dimension_value}</span>
                                <span className="item-count">{row.count.toLocaleString()} reviews</span>
                                <span className="nps-badge negative">
                                    ↓ {row.nps}
                                </span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className="dim-widget-empty">
                        <div className="empty-icon">✅</div>
                        No {dimConfig.plural} with NPS below 0 among those with 10+ reviews.
                    </div>
                )}
            </div>
            {hasStruggling && (
                <div className="dim-widget-footer">
                    <button
                        aria-expanded={false}
                        onClick={(e) => { e.stopPropagation(); onClick(); }}
                    >
                        View struggling {dimConfig.plural} →
                    </button>
                </div>
            )}
        </div>
    );
}

/**
 * Detail view: filtered NPS table for struggling items
 */
function StrugglingStoresDetail({ data, dimension, topicId, dimConfig, isLoading, onClose }) {
    return (
        <>
            <div className="dim-detail-header">
                <h3>Struggling {dimConfig.plural} (NPS &lt; 0, 10+ reviews)</h3>
                <button className="dim-detail-close" onClick={onClose}>← Back to Overview</button>
            </div>
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                    Loading...
                </div>
            ) : (
                <DimensionNPSDisplay
                    data={data}
                    dimension={dimension}
                    topicId={topicId}
                    initialSort={{ key: 'nps', dir: 'asc' }}
                    emptyMessage={`No ${dimConfig.plural} with NPS below 0 among those with 10+ reviews.`}
                />
            )}
        </>
    );
}

StrugglingStoresSummary.Detail = StrugglingStoresDetail;
export default StrugglingStoresSummary;
